import React from 'react';
import PropTypes from 'prop-types';

import CheckBox from '../Inputs/CheckBox';

function FormCheckbox({
  input: { value, name, onChange },
  title, mouseInKey, placement, titleLeft, containerClass, isRequired, checkContainer, disabled
}) {
  return (
    <CheckBox
    className={containerClass}
    titleLeft={titleLeft}
    checked={!!value}
    onChange={() => onChange(!value)}
    label={title}
    isRequired={isRequired}
    placement={placement}
    mouseInKey={mouseInKey}
    checkContainer={checkContainer}
    disabled={disabled}
  />
  );
}

FormCheckbox.propTypes = {
  input: PropTypes.object.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string
  ]),
  checkContainer: PropTypes.string,
  containerClass: PropTypes.string,
  mouseInKey: PropTypes.string,
  placement: PropTypes.string,
  isRequired: PropTypes.bool,
  titleLeft: PropTypes.bool,
  disabled: PropTypes.bool
};

FormCheckbox.defaultProps = {
  title: null,
  checkContainer: '',
  containerClass: '',
  mouseInKey: '',
  placement: 'top',
  titleLeft: true,
  isRequired: false,
  disabled: false
};

export default FormCheckbox;
